/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import upload from './upload/saga';
import menuRole from './menuRole/saga';
import reportBugs from './reportBugs/saga';
import adminCommunication from './adminCommunication/saga';
import supplierCommunication from './communication/supplierCommunication/saga';
import supplierCommunicationInfra from './communication/supplierCommunicationInfra/saga';
import communicationInfra from './communication/communicationInfra/saga';
import comCatalog from './communication/catalog/saga';
import comArea from './communication/area/saga';
import speTool from './speTool/saga';
import hnEvaluation from './hospitalNet/evaluation/saga';
import healthRegistration from './quality/healthRegistration/saga';
import healthLicense from './quality/healthLicense/saga';
import healthBPM from './quality/healthBPM/saga';
import productInfo from './quality/productInfo/saga';
import idxRptQuality from './quality/idxRptQuality/saga';

import cashReceipt from './finance/cashReceipt/saga';
import paymentReceipt from './finance/paymentReceipt/saga';

import assessment from './assessment/assessment/saga';
import section from './assessment/section/saga';
import question from './assessment/question/saga';
import section_equipment from './assessment/section_equipment/saga';
import answer from './assessment/answer/saga';
import assessment_project from './assessment/assessment_project/saga';
import evaluation from './assessment/evaluation/saga';
import evaluation_detail from './assessment/evaluation_detail/saga';
import assessment_document_type from './assessment/document_type/saga';
import document from './assessment/document/saga';
import evaluation_state from './assessment/evaluation_state/saga';
import assessment_type from './assessment/assessment_type/saga';
import evaluation_role from './assessment/evaluation_role/saga';
import evaluation_user from './assessment/evaluation_user/saga';
import evaluation_message from './assessment/evaluation_message/saga';
import equipment_stock from './assessment/equipment_stock/saga';
import equipment_stock_detail from './assessment/equipment_stock_detail/saga';
import equipment_stock_detail_item from './assessment/equipment_stock_detail_item/saga';
import assessment_category from './assessment/assessment_category/saga';
import equipment from './assessment/equipment/saga';
import idxRptEquipment from './assessment/idxRptEquipment/saga';
import otherReassignation from './assessment/otherReassignation/saga';

import trackingInstallation from './equipment/trackingInstallation/saga';
import assignTechnic from './equipment/assignTechnic/saga';
import validationDocumentReview from './equipment/validationDocumentReview/saga';
import scheduleMto from './equipment/scheduleMto/saga';
import request from './equipment/request/saga';
import task from './task/saga';
import taskType from './taskType/saga';
import mgmtProgram from './management/program/saga';
import mgmtComponent from './management/component/saga';
import mgmtProject from './management/project/saga';
import mgmtObjective from './management/objective/saga';
import mgmtOutcome from './management/outcome/saga';
import dpDeliveryPlan from './delivery_plan/delivery_plan/saga';
import dpDocumentation from './delivery_plan/documentation/saga';
import dpDeliveryPlanAudit from './delivery_plan/delivery_plan_audit/saga';
import dpTaskInspection from './delivery_plan/task_inspection/saga';
import dpTaskInspectionDestination from './delivery_plan/task_inspection_destination/saga';
import dpTaskDelivery from './delivery_plan/task_delivery/saga';
import acqAcquisition from './acquisition/acquisition/saga';
import acqAcquisitionDetail from './acquisition/acquisition_detail/saga';
import acqAcquisitionDetailNotBiddable from './acquisition/acquisition_detail_not_biddable/saga';
import taskEquipment from './task_equipment/saga';
import catVehicleType from './catalog/vehicle_type/saga';
import supVehicle from './supplier/vehicle/saga';
import supEmployee from './supplier/employee/saga';
import entSupplier from './enterprise/supplier/saga';
import entSupplierUser from './enterprise/supplier_user/saga';
import taskEmployee from './task/task_employee/saga';
import taskEmployeeAudit from './task/task_employee_audit/saga';
import taskVehicle from './task/task_vehicle/saga';
import taskVehicleAudit from './task/task_vehicle_audit/saga';

import idxPaymentReport from './report/idxPaymentReport/saga';

import ambulanceDocument from './ambulance/document/saga';
import ambulanceMaintenance from './ambulance/maintenance/saga';

import infrastructureDeliverable from './infrastructure/deliverable/saga';
import infrastructureLogbook from './infrastructure/logbook/saga';

export default function* rootSaga(getState) {
  yield all([
      authSagas(),
      upload(),
      menuRole(),
      reportBugs(),
      adminCommunication(),
      supplierCommunication(),
      supplierCommunicationInfra(),
      communicationInfra(),
      comCatalog(),
      comArea(),
      speTool(),
      healthRegistration(),
      healthLicense(),
      healthBPM(),
      productInfo(),
      idxRptQuality(),

      cashReceipt(),
      paymentReceipt(),

      hnEvaluation(),
      assessment(),
      section(),
      question(),
      answer(),
      assessment_project(),
      evaluation(),
      evaluation_detail(),
      assessment_document_type(),
      document(),
      evaluation_state(),
      assessment_type(),
      evaluation_role(),
      evaluation_user(),
      evaluation_message(),
      section_equipment(),
      equipment_stock(),
      equipment_stock_detail(),
      equipment_stock_detail_item(),
      assessment_category(),
      equipment(),
      idxRptEquipment(),
      otherReassignation(),
      trackingInstallation(),
      assignTechnic(),
      validationDocumentReview(),
      scheduleMto(),
      request(),
      task(),
      taskType(),
      mgmtProgram(),
      mgmtComponent(),
      mgmtProject(),
      mgmtObjective(),
      mgmtOutcome(),
      dpDeliveryPlan(),
      dpDocumentation(),
      dpDeliveryPlanAudit(),
      dpTaskInspection(),
      dpTaskInspectionDestination(),
      dpTaskDelivery(),
      acqAcquisition(),
      acqAcquisitionDetail(),
      acqAcquisitionDetailNotBiddable(),
      taskEquipment(),
      catVehicleType(),
      supVehicle(),
      supEmployee(),
      entSupplier(),
      entSupplierUser(),
      taskEmployee(),
      taskEmployeeAudit(),
      taskVehicle(),
      taskVehicleAudit(),

      idxPaymentReport(),
      ambulanceDocument(),
      ambulanceMaintenance(),
      infrastructureDeliverable(),
      infrastructureLogbook(),
  ]);
}
